import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HolidayType } from 'src/app/shared/models/billing-settings';

export interface HolidayDialogData {
  date?: string; // pre-filled date (YYYY-MM-DD)
  name?: string; // pre-filled name (for edit)
  type?: HolidayType;
  title?: string;
  showDateField?: boolean;
}

export interface HolidayDialogResult {
  date: string;
  name: string;
  type: HolidayType;
}

@Component({
    selector: 'app-holiday-dialog',
    templateUrl: './holiday-dialog.component.html',
    styleUrls: ['./holiday-dialog.component.scss'],
    standalone: false
})
export class HolidayDialogComponent implements OnInit {
  form: UntypedFormGroup;
  title: string;
  showDateField: boolean;

  holidayTypeOptions: { value: HolidayType; label: string }[] = [
    { value: 'holiday', label: 'Holiday' },
    { value: 'moratorium', label: 'Moratorium' },
    { value: 'weather', label: 'Weather' },
    { value: 'suspension', label: 'Suspension' },
  ];

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<HolidayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HolidayDialogData
  ) {
    this.title = data.title || 'Add holiday';
    this.showDateField = data.showDateField ?? !data.date;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      date: [this.data.date || '', this.showDateField ? [Validators.required] : []],
      name: [this.data.name || '', [Validators.required]],
      type: [this.data.type || 'holiday', [Validators.required]],
    });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value as HolidayDialogResult);
  }
}
